import React, { useEffect, useState } from 'react';
import { 
  IonContent, 
  IonPage, 
  IonProgressBar,
  IonIcon,
} from '@ionic/react';
import { checkmarkCircle, arrowBackCircle, arrowForwardCircle, addCircle } from 'ionicons/icons';
import Axios from 'axios';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';

import { 
  Toolbar, 
  Grid, 
  TextField, 
   FormControlLabel,
   Checkbox} from '@material-ui/core';

import {Notification, Diary, Admin} from '../assets/DataStructures'
import {NotificationComponent} from '../components/NotificationComponent'
import { useAuth0 } from "@auth0/auth0-react";
import useStyles from '../assets/cssClasses';
import {URLS} from '../assets/URLS';

interface dbProps {
  diary: Diary | null,
  type: string | "ADD",
  id: string | null,
  admin: Admin | null,
  ios: Boolean,
  ids: Array<string>,
}

const NewDiaryTab: React.FC<dbProps> = (props) => {

  const [processing, setProcessing] = useState<boolean>(false);
  const [activeStep, setActiveStep] = React.useState<number>(0);
  const steps = getSteps();
  const [diary, setDiary] = useState<Diary>(new Diary());

  const classes = useStyles();

  const { loginWithRedirect, logout, user, isAuthenticated } = useAuth0();

  
  useEffect(()=>{
    if(props.diary){
      setDiary(props.diary)
    }
  },[props.diary])

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  
  const postSurvey = () =>{
    setProcessing(true);
    console.log(diary);
    var formData = new FormData();
    
    formData.append('varsList', diary.file);
    formData.append('path', diary.path);
    formData.append('respondent_name', diary.respondent_name);
    formData.append('description', diary.description);
    formData.append('baseURL', diary.url);
    formData.append('apiKey', diary.api_key);
    formData.append('name', diary.name);
    formData.append('notifications', JSON.stringify(diary.messages));
    formData.append('admin', user.email);
    formData.append('active', JSON.stringify(diary.active));
    if(props.type==="UPDATE"){
      formData.append('id', props.id?props.id:'');
    }

      Axios.post(URLS.post_survey, formData).then(function(response){
        setProcessing(false);
      })

  } 
  
  function getSteps() {
    return ['Setting links and paths', 'Upload user IDs and links', 'Set the notifications'];
  }


  const addAutomatedNotification = () => {
    var n_messages = diary.messages?[...diary.messages]:[];
    n_messages.push(new Notification());
    setDiary({...diary,messages: n_messages});
  }



  const deleteAutoNotification = (ind:number) => {
    var n_auto_messages = [...diary.messages];
    n_auto_messages.splice(ind,1);
    setDiary({...diary,messages: n_auto_messages});
  }

  const setAttr = (value: any, name: string) => {
    var n_diary = {...diary};
    n_diary[name as keyof typeof n_diary] = value;
    console.log(n_diary);
    setDiary(n_diary);
  }

  const setAutoNotification = (ind: number, notification: Notification) => {
    console.log({ind: ind, notification: notification});
 
    diary.messages[ind] = notification;
 
  }


  const setFile = (files: any) => {
    diary.file = files[0];
  }

  
  function getStepContent(step: number) {
    switch (step) {
      case 0:
        return <React.Fragment>


        
            <TextField id="new_diary_name" label="Survey Name" value={diary.name} onChange={e => setAttr(e.target.value, 'name')} fullWidth={true}/>
   
            <TextField id="new_diary_name_resp" label="Respondent Survey Name" value={diary.respondent_name} onChange={e => setAttr(e.target.value, 'respondent_name')} fullWidth={true}/>

            <TextField id="description" label="Description" value={diary.description} onChange={e => setAttr(e.target.value, 'description')} fullWidth={true}/>
            
            <TextField id="new_diary_path" label="Survey Path" value={diary.path} onChange={e => setAttr(e.target.value, 'path')} fullWidth={true}/>
   
            <TextField id="new_diary_url" label="Base URL" value={diary.url} onChange={e => setAttr(e.target.value, 'url')} fullWidth={true}/>
 
            <TextField id="new_diary_apikey" label="API key" value={diary.api_key} onChange={e => setAttr(e.target.value, 'api_key')} fullWidth={true}/>


            <FormControlLabel
              control={
                <Checkbox
                  checked={diary.active?.valueOf()}
                  onChange={e => setAttr(e.target.checked, 'active')}
                  name="checkedActive"
                  color="primary"
                />
              }
              label="Active"
            />
 
          
        </React.Fragment>
      case 1:
        return <React.Fragment>
          {props.type === 'ADD' &&
            <React.Fragment>
              <label htmlFor='ids_file'>UPLOAD FILE</label>
              <input type='file' onChange={(e) => setFile(e.target.files)} id='ids_file' className={classes.file_input}></input>
            </React.Fragment>
          }
          {props.type !== 'ADD' &&
            <React.Fragment>
              <span>You can't edit the list of IDs</span>
            </React.Fragment>
          }

        </React.Fragment>;
      case 2:
        return <React.Fragment>
          
            {diary.messages?.map((a,ind)=>{
              return(
                <NotificationComponent auto_notification={a} propagateToParent={(notification: Notification) => setAutoNotification(ind, notification)} onDelete={() => deleteAutoNotification(ind)} mode='edit' saveParent={postSurvey} survey_id="" id=""></NotificationComponent>
              )
            })}
            <Button onClick={addAutomatedNotification} color="primary" className={classes.actionButton} startIcon={<IonIcon icon={addCircle}/>}>Add Notification</Button>
    
          
        </React.Fragment>
      default:
        return 'Unknown step';
    }
  }


  return (
    <IonPage>
      <IonContent>
 
    


        

        <Grid container spacing={2}>

          <Grid item xs={12}>
            <AppBar className={props.ios?classes.page_title_ios:classes.page_title} position="sticky">
              <Toolbar>
                <Typography className={classes.title} variant="h6">
                  <span className={classes.left_align_block}>Bright DSM | New Diary
                  {isAuthenticated &&
                      <span> | {user.email}</span>
                    }
                  </span>
                  <span className={classes.right_align_block}>
                    {!isAuthenticated &&
                      <Button onClick={() => loginWithRedirect()} className={classes.actionButton}>Log In as Admin</Button>
                    }
                    {isAuthenticated &&
                      <Button onClick={() => logout({ returnTo: window.location.origin })} className={classes.actionButton}>Log Out</Button>
                    }
                  </span>
                </Typography>
              </Toolbar>
            </AppBar>
          </Grid>
          {(!props.admin || !props.admin?.active) && 
            <Grid item xs={12}>
              Please login first. If you still can't access the desired functionality, please contact rdi@bright-mr.com for help and instructions.
            </Grid>
          }
          {props.admin?.active &&
          <Grid item xs={12}>
          <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel StepIconProps={{
                  classes: {
                    root: classes.stepper_label,
                    active: classes.stepper_label,
                    completed: classes.stepper_label,
                  }
                }}


                  color={'#008CBA'} className={classes.stepper_label}>{label}</StepLabel>
                <StepContent>
                  <Typography>{getStepContent(index)}</Typography>
                  <div>
                    <div>
                      <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={classes.backButton}
                        startIcon={<IonIcon icon={arrowBackCircle} />}
                      >
                        Back
                    </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNext}
                        className={classes.actionButton}
                        startIcon={activeStep === steps.length - 1 ? <IonIcon icon={checkmarkCircle} /> : <IonIcon icon={arrowForwardCircle} />}
                      >
                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                      </Button>
                    </div>
                  </div>
                </StepContent>
              </Step>
            ))}
          </Stepper>
          <Button color="primary" onClick={() => postSurvey()} startIcon={<IonIcon icon={checkmarkCircle} />} className={classes.actionButton}>SAVE</Button>
        </Grid>
          }


          
        </Grid>
        


        {processing &&
          <IonProgressBar type="indeterminate"></IonProgressBar>
        }
        
      </IonContent>
    </IonPage>
  );
};

export {NewDiaryTab};
